<template>
    <div
        v-if="eventData.availablePaymentTypes && eventData.availablePaymentTypes.length && (totalToPay !== 0 || paymentMethodWhenTotal0)">
        <h2>{{ $t('eventRegistration.payment.paymentType') }}</h2>
        <CardSelect
            v-model="paymentType"
            type="radio"
            :required="true"
            :name="$t('eventRegistration.payment.paymentType')">
            <AvailablePaymentTypeCardSelectItem
                v-for="availablePaymentType in eventData.availablePaymentTypes"
                :key="availablePaymentType.id"
                :available-payment-type="availablePaymentType" />
        </CardSelect>

        <template v-if="directDebitSelected">
            <div class="row">
                <div class="col-md-6">
                    <base-input
                        v-model="iban"
                        :label="$t('eventRegistration.payment.iban')"
                        required
                        :rules="{ibanInvalid: !checkingIban && ibanInvalid, pending: !!iban?.length && !!checkingIban}" />
                </div>
                <div class="col-md-6">
                    <base-input
                        v-model="alternativeAccountHolder"
                        :label="$t('eventRegistration.payment.alternativeAccountHolder')"
                        :rules="{max: 50}" />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import AvailablePaymentTypeCardSelectItem
    from "@/components/pages/registration/payment/AvailablePaymentTypeCardSelectItem";
import registrationPaymentMixin from "@/mixins/registration/registrationPaymentMixin";
import registrationPriceMixin from "@/mixins/registration/registrationPriceMixin";
import debounce from 'lodash/debounce';

export default {
    name: "PaymentType",
    components: {AvailablePaymentTypeCardSelectItem},
    mixins: [registrationPaymentMixin, registrationPriceMixin],
    data() {
        return {
            checkingIban: false,
            ibanInvalid: false,
            cancelCheckIban: null
        }
    },
    methods: {
        checkIban(iban) {
            this.cancelCheckIban && this.cancelCheckIban();
            this.checkIbanDebounced(iban)
        },
        checkIbanDebounced: debounce(async function (iban) {
            this.checkingIban = true
            this.ibanInvalid = false
            this.cancelCheckIban = this.$axios.CancelToken?.source();
            try {
                const result = await this.$axios.post(
                    this.$apiRoute('api.registration.validation'),
                    {
                        type: "iban",
                        data: iban
                    },
                    {
                        cancelToken: this.cancelCheckIban?.token
                    }
                )
                this.ibanInvalid = !result.data.isValid
            } catch (e) {
                console.error(e)
            }
            this.checkingIban = false
        }, 700),
    },
    computed: {
        totalToPay() {
            return this.getInvoiceTotal - this.getCouponTotal
        },
        directDebitSelected() {
            return this.selectedPaymentType?.type.id === 1
        }
    },
    watch: {
        'iban': {
            async handler(iban) {
                if (iban)
                    this.checkIban(iban)
            },
            immediate: true
        },
        paymentType(val) {
            this.iban = null;
            this.alternativeAccountHolder = null;
        },
        totalToPay(value) {
            if (value <= 0) {
                this.paymentType = null
                this.iban = null;
                this.alternativeAccountHolder = null;
            }
        }
    }
}
</script>

<style scoped>

</style>
